var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{attrs:{"to":_vm.route,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ href, navigate, isActive, isExactActive }){return [_c('a',{directives:[{name:"tip",rawName:"v-tip",value:({ content: _vm.tip }),expression:"{ content: tip }"}],staticClass:"w-full flex items-center px-4 py-3 text-sm font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500",class:[
      (_vm.exact ? isExactActive : isActive)
        ? 'bg-blue-600 bg-opacity-25 text-white'
        : 'hover:bg-blue-600 hover:bg-opacity-25 text-gray-300',
    ],attrs:{"href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.label)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }